import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../constants/configuration";

const { baseUrl, apiVersion, jobUrl } = CONFIG_VARS;

export const apiMutaion = createApi({
  reducerPath: "apiMutaion",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.tokens?.access_token;
      if (token) {
        headers.set("Authorization", `${token}`);
      }
      headers.set("product-id", "100");
      headers.set("tenant-id", "99999");
      return headers;
    }
  }),
  endpoints: (build) => ({
    examReport: build.mutation({
      query: (examId) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/report?exam_id=${examId}`,
        method: "GET"
      })
    }),

    examDetails: build.mutation({
      query: (examId) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/?exam_id=${examId}`,
        method: "GET"
      })
    }),

    events: build.mutation({
      query: () => ({
        url: `${baseUrl["1"]}/${apiVersion}/events`,
        method: "GET"
      })
    }),
    eventStatus: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/status?exam_id=${data.examId}&event_id=${data.event_id}`,
        method: "POST"
      })
    }),
    examStatus: build.mutation({
      query: (examId) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/status?exam_id=${examId}`,
        method: "GET"
      })
    }),
    advanceReport: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/advanced-report?exam_id=${data.examId}&event=${data.event}`,
        method: "GET"
      })
    }),
    advanceReportLSQ: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/advanced-report?exam_id=${data.examId}&event_id=${data.eventId}&event=${data.event}`,
        method: "POST"
      })
    }),
    mockTest: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/get-mock-test`,
        method: "POST",
        body: data
      })
    }),
    webEngage: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/webengage/event`,
        method: "POST",
        body: data
      })
    }),
    deviceDetailsLSQ: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/lsq?exam_id=${data.examId}&event_id=${data.eventId}`,
        method: "POST",
        body: data.payload
      })
    }),
    lsqONsuccesPayment: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/lsq/activity`,
        method: "POST",
        body: data
      })
    }),
    talkToExpertActivity: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/lsq/activity`,
        method: "POST",
        body: data
      })
    }),
    leadChapters: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/lsq/lead-activity`,
        method: "POST",
        body: data
      })
    }),
    getSchoolDetails: build.mutation({
      query: (schoolId) => ({
        url: `${jobUrl["1"]}/${apiVersion}/insights/get-school-details`,
        method: "POST",
        body: { school_id: schoolId }
      })
    }),
    careerCounsellingStatus: build.mutation({
      query: (eventId) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/status/career-counselling?event_id=${eventId}`,
        method: "POST"
      })
    }),
    lsqTracking: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/lsq/deeplink-activity`,
        method: "POST",
        body: data
      })
    }),
    bookDemoLsq: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/student-event-mapping/demo-booking-activity`,
        method: "POST",
        body: data
      })
    }),
    updateExamID: build.query({
      query: (question_paper_id) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/updated-exam-id/${question_paper_id}`,
        method: "GET"
      })
    }),
    studentExamStatus: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/student-exam-status?event_id=${data.event_id}`,
        method: "POST"
      })
    }),
    checkCertificateStatus: build.mutation({
      query: (data) => ({
        url: `${baseUrl["1"]}/${apiVersion}/exams/certificate-status?event_id=${data.event_id}`,
        method: "GET"
      })
    })
  })
});

export const {
  useEventsMutation,
  useExamReportMutation,
  useExamDetailsMutation,
  useEventStatusMutation,
  useExamStatusMutation,
  useAdvanceReportMutation,
  useAdvanceReportLSQMutation,
  useMockTestMutation,
  useWebEngageMutation,
  useDeviceDetailsLSQMutation,
  useLsqONsuccesPaymentMutation,
  useTalkToExpertActivityMutation,
  useGetSchoolDetailsMutation,
  useLeadChaptersMutation,
  useCareerCounsellingStatusMutation,
  useLsqTrackingMutation,
  useUpdateExamIDQuery,
  useStudentExamStatusMutation,
  useBookDemoLsqMutation,
  useCheckCertificateStatusMutation
} = apiMutaion;
